import { withDefault, StringParam } from 'use-query-params';
import {
  CustomStringParam,
  FilterType,
  SortDir,
  BaseellaStatus,
  SchemaFilterType,
  BaseellaStatusTitle,
} from '@ui/src';

export const columns = [
  {
    name: 'id',
    label: 'Transaction identifier',
    hidden: true,
    sortable: true,
  },
  {
    name: 'transferDate',
    label: 'Transfer Date',
    sortable: true,
  },
  {
    name: 'currencyId',
    label: 'Currency',
    sortable: true,
  },
  {
    name: 'baseellaStatus',
    label: 'Status',
    sortable: true,
  },
  {
    name: 'sum',
    label: 'Amount',
    sortable: true,
  },
  {
    name: 'recipientAccountNumber',
    label: 'Beneficiary account',
    sortable: true,
  },
  {
    name: 'acceptedIn',
    label: 'Date Accepted',
    sortable: true,
    filterModalPlacement: 'right',
  },
  {
    name: 'paymentType',
    label: 'Payment type',
    sortable: true,
    filterModalPlacement: 'right',
  },
  {
    name: 'senderAccountNumber',
    label: 'Account/IBAN',
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'pspPartnerAccountNumber',
    label: 'Partner PSP Account',
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'documentNumber',
    label: 'Document number',
    hidden: true,
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'chargeType',
    label: 'Charges type',
    hidden: true,
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'info',
    label: 'Payment details',
    hidden: true,
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'paymentOrderId',
    label: 'Payment Order',
    hidden: true,
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'remitterFullName',
    label: 'Sender full name',
    filterModalPlacement: 'right',
    hidden: true,
    headerRender: () => 'Sender Info',
    sortable: true,
  },
  {
    name: 'remitterCountry',
    label: 'Sender Country',
    hidden: true,
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'remitterAddress',
    label: 'Sender Address',
    filterModalPlacement: 'right',
    hidden: true,
    sortable: true,
  },
  {
    name: 'remitterBankBIC',
    label: 'Sender BIC',
    hidden: true,
    headerRender: () => 'Sender Bank',
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'remitterBankCountry',
    label: 'Sender Bank Country',
    hidden: true,
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'remitterBankCorrespondentAccount',
    label: 'Sender Bank Corr. Account',
    hidden: true,
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'remitterBankName',
    label: 'Sender Bank Name',
    hidden: true,
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'remitterBankAddress',
    label: 'Sender Bank Address',
    hidden: true,
    sortable: true,
  },
  {
    name: 'intermediaryBankCountry',
    label: 'Bank Country',
    hidden: true,
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'intermediaryBankCorrespondentAccount',
    label: 'Bank Corr. Account',
    hidden: true,
    sortable: true,
    filterModalPlacement: 'right',
  },
  {
    name: 'intermediaryBankName',
    label: 'Bank Name',
    hidden: true,
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'intermediaryBankBIC',
    label: 'Bank BIC',
    hidden: true,
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'intermediaryBankAddress',
    label: 'Bank Address',
    hidden: true,
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'riskScore',
    label: 'AML: Weighted transaction score',
    filterModalPlacement: 'right',
    hidden: true,
    headerRender: () => 'AML',
    sortable: true,
  },
  {
    name: 'deletedAt',
    label: '',
    hidden: true,
  },
  {
    name: 'values',
    label: '',
    hidden: true,
  },
];

export const columnsLabels = {
  transferDate: 'Date created',
  transferDateFrom: 'Date created From',
  transferDateTo: 'Date created To',
  acceptedIn: 'Date Accepted',
  currencyId: 'Currency',
  baseellaStatus: 'Status',
  recipientAccountNumber: 'Beneficiary account',
  paymentType: 'Payment type',
  senderAccountNumber: 'Account/IBAN',
  pspPartnerAccountNumber: 'Partner PSP Account',
  info: 'Payment details',
  paymentOrderId: 'Payment Order',
  id: 'Transaction identifier',
  remitterFullName: 'Sender full name',
  remitterCountry: 'Sender country',
  remitterBankBIC: 'Sender Bank BIC',
  remitterBankName: 'Sender Bank BIC',
  intermediaryBankName: 'Intermediary Bank Name',
  intermediaryBankBIC: 'Intermediary Bank BIC',
  documentNumber: 'Document number',
};

export const defaultSorter = {
  sortProp: columns[1].name,
  sortDir: SortDir.DESC,
};

export const schema = {
  transferDate: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
    queryNames: ['transferDateFrom', 'transferDateTo'],
  },
  transferDateFrom: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  transferDateTo: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  documentNumber: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  // acceptedIn: {
  //   value: CustomStringParam,
  //   type: SchemaFilterType.DATE,
  // },
  currencyId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  senderAccountNumber: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  baseellaStatus: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  recipientAccountNumber: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  paymentType: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  pspPartnerAccountNumber: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  info: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  paymentOrderId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  id: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  remitterFullName: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  remitterCountry: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  remitterBankBIC: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  remitterBankName: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  intermediaryBankName: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  intermediaryBankBIC: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  sortProp: {
    value: withDefault(StringParam, defaultSorter.sortProp),
    type: SchemaFilterType.STRING,
  },
  sortDir: {
    value: withDefault(StringParam, defaultSorter.sortDir),
    type: SchemaFilterType.STRING,
  },
};

export const expandableColumns = [
  {
    name: 'transferDate',
    label: 'Date',
  },
  {
    name: 'currencyId',
    label: 'Currency',
  },
  {
    name: 'status',
    label: 'Status',
  },
  {
    name: 'sum',
    label: 'Amount',
  },
  {
    name: 'debitAccountId',
    label: 'Debit account No.',
  },
  {
    name: 'debitAccount',
    label: 'Debit account description',
  },
  {
    name: 'creditAccountId',
    label: 'Credit account No.',
  },
  {
    name: 'creditAccount',
    label: 'Credit account description',
  },
  {
    name: 'documentNumber',
    label: 'Doc. N',
  },
];

export const filtersSchema = [
  {
    name: 'currencyId',
    type: FilterType.AUTOCOMPLETE_MULTIPLE,
    placeholder: 'Enter currency...',
  },
  {
    name: 'baseellaStatus',
    type: FilterType.CHECKBOX,
    withClearButton: true,
    fields: [
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.DRAFT,
        value: BaseellaStatus.DRAFT,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.NONE,
        value: BaseellaStatus.NONE,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.UNDEFINED_FUNDS,
        value: BaseellaStatus.UNDEFINED_FUNDS,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.MISSING_PAYER,
        value: BaseellaStatus.MISSING_PAYER,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.NEW,
        value: BaseellaStatus.NEW,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.HELD,
        value: BaseellaStatus.HELD,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.SENT,
        value: BaseellaStatus.SENT,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.PROC,
        value: BaseellaStatus.PROC,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.ARCH,
        value: BaseellaStatus.ARCH,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.REV,
        value: BaseellaStatus.REV,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.AML,
        value: BaseellaStatus.AML,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.AML_INFO,
        value: BaseellaStatus.AML_INFO,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.AML_REJ,
        value: BaseellaStatus.AML_REJ,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.AML_DONE,
        value: BaseellaStatus.AML_DONE,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.REJECTED,
        value: BaseellaStatus.REJECTED,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.NOT_SIGNED,
        value: BaseellaStatus.NOT_SIGNED,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.READY_TO_SEND,
        value: BaseellaStatus.READY_TO_SEND,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.READY_TO_PSP,
        value: BaseellaStatus.READY_TO_PSP,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.ACCP_OUT,
        value: BaseellaStatus.ACCP_OUT,
      },
    ],
  },
  {
    name: 'transferDate',
    type: FilterType.DATE_RANGE,
    pickerType: 'twoPickers',
  },
  // {
  //   name: 'acceptedIn',
  //   type: FilterType.DATE,
  //   pickerType: 'twoPickers',
  // },
  {
    name: 'recipientAccountNumber',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Search by account...',
  },
  {
    name: 'paymentType',
    type: FilterType.AUTOCOMPLETE_MULTIPLE,
    placeholder: 'Enter payment type...',
  },
  {
    name: 'senderAccountNumber',
    type: FilterType.TEXT,
    placeholder: 'Enter Account/IBAN...',
  },
  {
    name: 'pspPartnerAccountNumber',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Search by account...',
  },
  {
    name: 'info',
    type: FilterType.TEXT,
    placeholder: 'Enter payment details...',
  },
  {
    name: 'paymentOrderId',
    type: FilterType.TEXT,
    placeholder: 'Enter payment order...',
  },
  {
    name: 'id',
    type: FilterType.TEXT,
    placeholder: 'Enter identifier...',
  },
  {
    name: 'remitterFullName',
    type: FilterType.TEXT,
    placeholder: 'Enter name...',
  },
  {
    name: 'remitterCountry',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Search by country...',
  },
  {
    name: 'remitterBankBIC',
    type: FilterType.TEXT,
    placeholder: 'Enter BIC...',
  },
  {
    name: 'remitterBankName',
    type: FilterType.TEXT,
    placeholder: 'Enter bank name...',
  },
  {
    name: 'intermediaryBankName',
    type: FilterType.TEXT,
    placeholder: 'Enter bank name...',
  },
  {
    name: 'intermediaryBankBIC',
    type: FilterType.TEXT,
    placeholder: 'Enter BIC...',
  },
  {
    name: 'documentNumber',
    type: FilterType.TEXT,
    placeholder: 'Enter document number...',
  },
];
